import React from "react";
import { Col, Row } from "react-bootstrap";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import { TransactionCard, TransactionHeader, TransactionSign } from "pages/_components/TransactionCard";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { transactionStatus } from "pages/transactions/constants";
import Notification from "pages/_components/Notification";
import { actions as echeckActions } from "reducers/echecks";
import { useTransaction } from "hooks/useTransactions";
import { useDispatch } from "react-redux";
import { bool } from "prop-types";
import { isIOS } from "react-device-detect";
import ReturnSummaryBody from "./ReturnSummary";

const ReturnTransactionPage = ({ isDesktop }) => {
    const dispatch = useDispatch();

    const formatTransaction = (data, idTransaction) => {
        dispatch(
            echeckActions.setEchecksToDoActions({ action: data.action, echeqList: data.echeqList, idTransaction }),
        );

        return data.echeqList[0].cuit_solic_devol;
    };

    const { isLoading, transaction, handleSignTransaction, showSignButton, push, id } = useTransaction(
        "/echeqs/action/return/accept",
        echeckActions.setRequestReturnSolicitanInformation,
        echeckActions.cleanEcheckTicket,
        formatTransaction,
    );
    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        "echecks.acceptRetun",
        id,
        "echecks/return",
    );
    const isFinished = transactionStatus.FINISHED === transaction.idTransactionStatus;

    return (
        <>
            {isFinished && <Notification scopeToShow="echecks/return" />}
            <ResponsiveHeader ticket metaTitle="echecks.acceptRetun">
                {isFinished && (
                    <>
                        <DesktopButtons>
                            <Button
                                className="btn btn-outline"
                                image="images/figma/icon/download.svg"
                                label="global.download"
                                onClick={handlePrint}
                                block={false}
                            />
                        </DesktopButtons>
                        <MobileButtons
                            image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                            <Action labelKey="global.share" handleClick={handlePrintMobile} />
                            <Action labelKey="global.download" handleClick={handleShareMobile} />
                        </MobileButtons>
                    </>
                )}
            </ResponsiveHeader>
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="echecks.acceptRetun" />
                            <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                                <ReturnSummaryBody />
                                <TransactionSign isDesktop={isDesktop} showMoreData />
                            </Col>
                        </TransactionCard>
                    </div>
                    <Row className="form-actions no-print">
                        <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                            <Button
                                onClick={() => dispatch(push("/desktop"))}
                                label="forms.transaction.ticket.actions.backToHome"
                                className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                            />
                        </Col>
                        {showSignButton && (
                            <Col xs={12} md={4}>
                                <Button
                                    onClick={handleSignTransaction}
                                    label="forms.signTransaction.link"
                                    className="btn btn-primary"
                                />
                            </Col>
                        )}
                    </Row>
                </div>
            </MainContainer>
        </>
    );
};

ReturnTransactionPage.defaultProps = {
    isDesktop: true,
};

ReturnTransactionPage.propTypes = {
    isDesktop: bool,
};

export default ReturnTransactionPage;
